export const PLANS_MIN_COUNT = 2;
export const PLANS_MAX_COUNT = 4;
